import catalog from '@/data/catalog.js'
import products from '@/data/products.js'

const state = {
  categories: [],
  currentCategory: null,
  products: []
}

const mutations = {
  'SET_PRODUCTS' (state, products) {
    state.products = products
  },
  'SET_CATEGORIES' (state, categories) {
    state.categories = categories
  },
  'ADD_CATEGORY' (state, categoriesName) {
    state.categories.push(categoriesName)
  },
  'SET_CURRENT_CATEGORY' (state, categoryID) {
    state.currentCategory = categoryID
  },
  'ADD_PRODUCT' (state, product) {
    state.categories.find(cat => { if (cat.id === state.currentCategory) return cat.items.push(product.id) })
    state.products.push(product)
  },
  'REMOVE_CATEGORY' (state, id) {
    state.categories = state.categories.filter(item => { return item.id !== id })
  },
  'REMOVE_PRODUCT' (state, id) {
    state.categories.find(cat => {
      if (cat.id === state.currentCategory) {
        const newItemsArray = cat.items.filter(item => {
          // return item.id.match(id)
          return item.id !== id
        })
        cat.items = newItemsArray
      }
    })
    // state.categories = state.categories.filter(item => { return item.id !== id })
  }
}

const actions = {
  initCatalog: ({commit}) => {
    commit('SET_CATEGORIES', catalog)
    commit('SET_PRODUCTS', products)
  }
}

const getters = {
  getCategories: state => state.categories,
  getProducts: state => state.products,
  getProductName: (state, ID) => {
    const product = state.products.find(product => product.id === ID)
    return product ? product.name : null
  },
  getCurrentCategory: state => state.currentCategory
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/catalogStore.js